import { useEffect, useRef } from "react";
import { isAuthenticated } from "@/services/auth";
import api from "@/services/api";
import { useTenant } from "@/context/TenantContext";

const PING_INTERVAL = 10 * 60 * 1000;

export const useKeepAlive = () => {
  const { tenantData } = useTenant();
  const tenantId = tenantData?.tenant?._id;
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const hasPingedOnce = useRef(false);
  useEffect(() => {
    if (!tenantId || !isAuthenticated()) return;
    const ping = () => {
      api.get(`/health/${tenantId}`).catch(() => {});
    };
    // only ping immediately on very first mount, not on re-runs
    if (!hasPingedOnce.current) {
      ping();
      hasPingedOnce.current = true;
    }
    intervalRef.current = setInterval(ping, PING_INTERVAL);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [tenantId]);
};
